import api from "./index";

//import axios from "axios";

class account {
  async infoAccount(correoElectronico) {
    const res = await api.get(
      process.env.REACT_APP_BACK_NEXT + "/v1/account?email=" + correoElectronico
    );
    //console.log(res);
    return res.data.data;
  }


}

export default new account();
